<template>
    <flex-element :element-type="elementType" class-default-inline="f-w-1/1 f-bg-orange-600 f-text-white">
        <o-container
            class="f-flex"
            class-default="f-w-1/1 f-p-1 fu-boxed"
            display-name="Alert Banner Container"
            v-bind="element(1)"
            @element-updated="elementUpdated"
        >
            <template v-slot="{ element, elementUpdated }">
                <drop-zone-single
                    class-default="f-w-1/1 f-flex-row"
                    v-bind="element(1)"
                    @element-updated="elementUpdated"
                />
                <a-button
                    class="alert-dismiss"
                    class-default="f-py-0.5 f-px-0.5 f-rounded-full f-border-white hover:f-border-white f-border-solid f-border-1 f-no-underline hover:f-no-underline f-cursor-pointer f-text-center f-w-1.75 f-h-1.75"
                    v-bind="element(2)"
                    @element-updated="elementUpdated"
                    @click.native="dismissAlert"
                >
                    ×
                </a-button>
            </template>
        </o-container>
    </flex-element>
</template>

<script>
import { mapState } from 'vuex';
import baseOrganism from '@/mixins/base-organism/base-organism-smart';

export default {
    mixins: [baseOrganism],

    props: {
        displayName: {
            type: String,
            default: 'Alert Banner',
        },
    },

    data() {
        return {
            cssDisplay: 'block',
            isDismissed: false,
        };
    },

    computed: {
        ...mapState({
            previewMode: state => state.page.previewMode,
        }),

        hide() {
            return this.previewMode && this.isDismissed;
        },
    },

    methods: {
        dismissAlert() {
            this.isDismissed = true;
        },
    },
};
</script>

<style lang="scss">
.alert-dismiss {
    line-height: 0;
}
</style>
